var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-form',{scopedSlots:_vm._u([{key:"Head",fn:function(){return undefined},proxy:true},{key:"Main",fn:function(){return [_c('hello-world')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }